import React from 'react';
import PropTypes from 'prop-types';

const Title = props => <div className='common' style={{fontWeight: '700', textTransform: 'uppercase'}}>{props.text}</div>

Title.propTypes = {
    text: PropTypes.string.isRequired
}

export default Title;